// extracted by mini-css-extract-plugin
module.exports = {"block":"AdminLink_block__XWvj7","compact":"AdminLink_compact__DdhGT"};